







import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class BtFormGroup extends Vue{
    @Prop()classes!:string;
    @Prop()label!:string;
    @Prop()name!:string;
    @Prop()value!:string;
    @Prop()error!:string;

    public compValue: string = "";

    mounted() {
        if (this.value)
            this.compValue = this.value;
    }

    @Watch('compValue')
    compValueChanged(val: number){
            this.$emit('input', this.compValue);
    }

    @Watch('value')
    valueChanged(val: string){
        this.compValue = val;
    }
}
